module.exports = __webpack_public_path__ + "img/login.81e3ef50.png";